module.exports = __webpack_public_path__ + "bd46678c170f736fed5cfdb1779751df.pdf";